'use client';

import { useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';

/**
 * Supabase recovery emails sometimes redirect to Site URL (/) when the
 * exact redirectTo path is not allowlisted. Capture recovery tokens on any
 * page and send the user to /reset-password with tokens preserved.
 */
export default function AuthRecoveryRedirect() {
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (
      pathname?.startsWith('/reset-password') ||
      pathname?.startsWith('/update-password') ||
      pathname?.startsWith('/auth/callback')
    ) {
      return;
    }

    const hash = window.location?.hash || '';
    const hashParams = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
    const searchParams = new URLSearchParams(window.location.search);

    const hashType = hashParams?.get('type');
    const searchType = searchParams?.get('type');
    const code = searchParams?.get('code');
    const tokenHash = searchParams?.get('token_hash');

    const isRecovery =
      hashType === 'recovery' ||
      searchType === 'recovery' ||
      Boolean(tokenHash && (searchType === 'recovery' || !searchType));

    if (!isRecovery && !(code && searchType === 'recovery')) return;

    const target = `/reset-password${window.location?.search || ''}${hash}`;
    window.location?.replace(target);
  }, [pathname, router]);

  return null;
}
